import React from 'react';
import PropTypes from 'prop-types';

import BasicModal from "components/common/BasicModal";
import {isNoU} from "../../utils/DBUtils";
import ErrorDisplay from "components/common/ErrorDisplay";
import {basicForm} from "utils/helpers";
import config from './forgotPasswordFormConfig';
import components from 'components/forms/Component Sets/UnvalidatedBasicFormComponents';
import ResourceForm from "components/forms/ResourceForm";
import { Message } from 'semantic-ui-react';
import {FormattedMessage} from "react-intl";

const ForgotPasswordModal = (props) => (
  <BasicModal header="Reset your password"
              specialType="primary-modal fadeInUp animResponse"
              modalSize="small"
              actions={[
                {
                  label: "Reset Password",
                  action: props.submit,
                  displayType: "button",
                  primaryCheck: true
                }
              ]}
              closeOnDimmerClick={true}
              open={props.modalOpen}
              onClose={props.handleClose}>
  <ResourceForm resource={props.formData}
                config={config}
                components={components}
                errors={props.errors}
                onValueChanged={props.onValueChanged}
                onValidationError={props.onValidationError}/>
    <ErrorDisplay error={props.error}/>
    {props.showSuccessMessage ?
      <Message className="success-message animResponse fadeInDown">
        <Message.Header><FormattedMessage id={'login.forgetPasswordSuccess'}/></Message.Header>
      </Message>
      : ""}
  </BasicModal>
)

export default ForgotPasswordModal;



// WEBPACK FOOTER //
// ./public/pages/Login/ForgotPasswordModal.jsx